import {FormBuilderAnswerableSignature, FormBuilderQuestion} from "@/types";
import {ExclamationCircleIcon} from '@heroicons/react/20/solid'
import React, {useEffect, useState} from "react";
import SignatureCanvas from 'react-signature-canvas'
import Button from "@/Components/Button";

interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

export default function AnswerableSignature<T extends { answerable: FormBuilderAnswerableSignature }>({
                                                                                                          question,
                                                                                                          data,
                                                                                                          setData,
                                                                                                          hasError,
                                                                                                          settings
                                                                                                      }: Props) {

    // check if the default is null and convert it to a string because React doesn't like null
    const value: string = !data[question.id] ? "" : data[question.id];
    const [localValue, setLocalValue] = useState(value);
    const [canvasRef, setCanvasRef] = useState(null);
    useEffect(() => {
        if (data[question.id] && canvasRef?.isEmpty()) {
            console.log('setting effect', canvasRef, data[question.id])
            canvasRef?.fromDataURL(data[question.id], {width: 250, height: 100})
        }

    }, [canvasRef])

    return (
        <div className="relative mt-1">
            <div className="justify-between flex text-sm text-gray-400 relative">
                <div className="border border-gray-100 rounded-md w-[250px] h-[100px]">
                    <SignatureCanvas
                        ref={(ref) => {
                            console.log('ref', ref, data[question.id])
                            if (ref && ref.isEmpty()) {
                                setCanvasRef(ref)
                            }
                        }}
                        onCanvasCreated={(ref) => {
                            if (data[question.id]) {
                                console.log('setting ref', data[question.id])
                                ref.fromDataURL(data[question.id])
                            }
                        }}
                        penColor='black'
                        canvasProps={{width: 250, height: 100, className: 'sigCanvas'}}
                        clearOnResize={true}
                        onEnd={() => {
                            setData(question.id, canvasRef?.toDataURL('image/png', 0.2))
                        }}
                    />
                </div>
            </div>
            <Button style={"light"} size={"sm"} onClick={() => {
                canvasRef?.clear()
            }}>Clear</Button>
            {(hasError) ? (errorBadge()) : (<></>
            )}
        </div>
    )
        ;

}

function errorBadge() {
    return (
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
        </div>
    )
}
